import React from 'react';
import styled from 'styled-components';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import { withRouter } from 'react-router';

const ColoredDiv = styled.div`
    background-color: ${props => props.isDay ? '#33b8ff' : 'black'}
`;

const layout = (props) => {
    return (<ColoredDiv isDay={props.location.state ? props.location.state.isDay : true}>
        <Header/>
        {props.children}
        <Footer/>
    </ColoredDiv>);
};

export default withRouter(layout);


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js